import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import en from '@angular/common/locales/en';
import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { appConfig } from './app.config';
import { NbAuthModule } from './auth/auth.module';
import { AppModuleInjector } from './services/app-module-injector';
import { CatchErrorsInterceptor } from './services/catch-errors-interceptor';
import { LoaderInterceptor } from './services/spinner-interceptor';
import { AppToastComponent } from './shared/app-toast/app-toast.component';
import { MobileResizeFixDirective } from './shared/fixes/mobile-resize-fix.directive';
import { ConfigLoader, ConfigModule } from './shared/ngx-config/core';
import { ConfigHttpLoader } from './shared/ngx-config/http-loader';
import { SpinnerComponent } from './shared/spinner/spinner.component';

registerLocaleData(en);

@NgModule({
  declarations: [AppComponent, SpinnerComponent, MobileResizeFixDirective],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ConfigModule.forRoot({
      provide: ConfigLoader,
      useFactory: (http: HttpClient) => new ConfigHttpLoader(http, `./assets/config/${location.host.replace(':', '_')}.json`),
      deps: [HttpClient],
    }),
    ToastModule,
    NbAuthModule,
    ConfirmDialogModule,
    AppToastComponent,
  ],
  providers: [
    ConfirmationService,
    MessageService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CatchErrorsInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    ...appConfig.providers,
  ],
})
export class AppModule {
  constructor(private injector: Injector) {
    AppModuleInjector.injector = this.injector;
  }
}
